import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CarDetailsComponent} from './components/pages/car-details/car-details.component';
import {ShowroomComponent} from './components/pages/showroom/showroom.component';


const routes: Routes = [
  { path: 'details/:companyId/:make/:series/:stock_id', pathMatch: 'full', component: CarDetailsComponent },
  { path: 'details/:companyId/:make/:stock_id', pathMatch: 'full', component: CarDetailsComponent },
  { path: '', pathMatch: 'full', component: ShowroomComponent},
  { path: 'buy-a-car/:make/:series/:year/:priceLow/:priceHigh/:kmLow/:kmHigh', component: ShowroomComponent },
  {path: 'buy-a-car/:used/:make', pathMatch: 'full', component: ShowroomComponent},
  {path: '**', redirectTo: '', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
